import { dailyReportActionTypes } from '@/components/dailyReport/Constants';

import type {
	DailyReportData,
	GetDailyReportErrorAction,
	GetDailyReportRequestAction,
	GetDailyReportSuccessAction,
} from '@/components/dailyReport/types';

export function getDailyReportRequest(date?: string): GetDailyReportRequestAction {
	return {
		type: dailyReportActionTypes.GET_DAILY_REPORT_REQUEST,
		payload: {
			date,
		},
	};
}

export function getDailyReportSuccess(data: DailyReportData): GetDailyReportSuccessAction {
	return {
		type: dailyReportActionTypes.GET_DAILY_REPORT_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getDailyReportError(error?: Error | string): GetDailyReportErrorAction {
	return {
		type: dailyReportActionTypes.GET_DAILY_REPORT_ERROR,
		error: true,
		payload: {
			error,
		},
	};
}
